import { Alert, styled } from '@mui/material';

export const StyledAlert = styled(Alert)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.info.main,
  borderRadius: '3px',
  color: 'inherit',
  paddingLeft: '30px',

  '::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '7px',
    height: '100%',
    borderTopLeftRadius: '3px',
    borderBottomLeftRadius: '3px',
    backgroundColor: theme.palette.info.dark,
  },

  '& .MuiAlert-icon': {
    color: 'inherit',
  },
}));
